/**
 * Customer session token helpers.
 * The session token is issued by the backend after Twilio verification
 * and stored in localStorage. It is valid for 30 days.
 */

export function getSessionToken() {
  return localStorage.getItem('customer_session_token') || null;
}

export function setSessionToken(token) {
  if (token) {
    localStorage.setItem('customer_session_token', token);
  }
}

export function clearSessionToken() {
  localStorage.removeItem('customer_session_token');
}

/**
 * Returns { session_token, square_customer_id } to spread into any
 * backend function payload that requires authentication.
 * Returns empty object if not available (guest / not logged in).
 */
export function getSessionPayload() {
  const token = getSessionToken();
  const rawData = localStorage.getItem('customer_data');
  if (!token || !rawData) return {};
  try {
    const data = JSON.parse(rawData);
    return { session_token: token, square_customer_id: data.square_customer_id };
  } catch {
    return {};
  }
}